import { StructuredContent } from '@repo/supergraph/structuredContent/types';

export enum TableOfContentsEntryType {
  H2 = 'H2',
  H3 = 'H3',
  TableOfContentsTarget = 'TableOfContentsTarget',
}

export type TableOfContentsEntry = {
  content?: StructuredContent;
  target: string;
  type: TableOfContentsEntryType;
  textContent: string;
};
